module.exports = __webpack_public_path__ + "img/maestro.5b115537.svg";